export default __webpack_public_path__ + "static/exclusiveTools-12ba7431de4a18e9144eaae472d19f28.png";